/**
 * @author Angel Ruiz <angel.ichazu@gmail.com>
 * 06-Dic-2021
 */
export const ERROR = 'ERROR_PROCESS_AUTH'
export const SUCCESS_PROCESS = 'SUCCESS_PROCESS_AUTH'
export const RESET_STATE_AUTH = 'RESET_STATE_AUTH'
export const UPDATE_TOKEN_LOGIN = 'UPDATE_TOKEN_LOGIN'

